import React, { useState } from "react";
import { DownOutlined, PlusOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";

const StyledDetails = styled.details`
  border-radius: 8px;
  margin-bottom: 20px;

  summary {
    list-style: none;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      display: flex;
      gap: 10px;
      align-items: center;

      .icon {
        transition: transform 0.3s ease;
        display: inline-flex;
      }
    }
  }

  /* When details is open - use child combinator for specificity */
  &[open] > summary .title .icon {
    transform: rotate(180deg);
  }

  &[open] > summary {
    margin-bottom: 10px;
  }
`;

const CustomCollapse = ({
  title = "Notes",
  children,
  headerRight = "",
  titleClass = "",
  ...restProps
}) => {
  return (
    <StyledDetails {...restProps}>
      <summary className="collapse-header">
        <span className={titleClass + " title"}>
          <span>
            <DownOutlined className="icon" />
          </span>
          <span>{title}</span>
        </span>
        <span>{headerRight}</span>
      </summary>
      <div className="collapse-content">{children}</div>
    </StyledDetails>
  );
};

export default CustomCollapse;
